<template>
  <div id="contenedor-contrato-firmas-mobile">
    <v-data-table
      :headers="headers"
      :items="listadoFirmas">
       <template v-slot:[`item.acciones`]="{ item }">
        <v-btn
          v-if="mixValidaScopesActions(3)"
          icon
          @click="borrar(item)">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoFirmasMobile',
  props: {
    listadoFirmas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Orden',
          align: 'start',
          sortable: false,
          value: 'orden',
          width: '1%',
        },
        { text: 'Funcionario', sortable: false, value: 'funcionario.nombre' },
        { text: '', sortable: false, value: 'acciones' },
      ],
    };
  },
  methods: {
    borrar(firma) {
      eventBus.$emit('eliminar-firma-contrato', firma);
    },
  },
};
</script>

<style lang="scss">

</style>
